<template>
  <div>
    <v-row>
      <v-col cols="12">
        <data-table
            ref="table"
            :headers="headers"
            :items="items"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
        >
          <template v-slot:item.id="{ item }">
            {{ item.id }}
          </template>
          <template v-slot:item.status="{ item }">
            {{ getStatusText(item.status) }}
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ localDateTime(item.createdAtDto) }}
          </template>
          <template v-slot:item.update="{ item }">
            <v-select
                style="width:200px"
                v-model="item.status"
                label="Status"
                placeholder=" "
                :items="statusValues"
                item-value="value"
                item-text="text"
                @change="update(item)"
            />
          </template>
        </data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from '../services/api';
import DataTable from "@/components/data-table/DataTable";
import formatters from '@/mixins/formatters';
import {OfferJoinStatus, getStatusText} from '@/enums/OfferJoinStatus';
import permissions from '@/mixins/permissions';

export default {
  mixins: [
    formatters,
    permissions,
  ],
  components: {
    DataTable,
  },
  data() {
    return {
      status: null,
      statuses: OfferJoinStatus,
      total: 0,
      options: {},
      items: [],
      loading: true,
      headers: [
        {text: 'ID', value: 'id', sortable: false},
        {text: 'Imię i nazwisko', value: 'name', sortable: false},
        {text: 'Telefon', value: 'phone', sortable: false},
        {text: 'E-mail', value: 'email', sortable: false},
        {text: 'NIP', value: 'nip', sortable: false},
        {text: 'Opis', value: 'description', sortable: false},
        {text: 'Status', value: 'status', sortable: false},
        {text: 'Akcje', value: 'update', sortable: false},
      ],
      statusValues: [
        {
          value: 'new',
          text: 'Nowy'
        },
        {
          value: 'processing',
          text: 'Przetwarzanie'
        },
        {
          value: 'completed',
          text: 'Zakończone'
        },
      ]
    }
  },
  methods: {
    async getList() {
      this.loading = true;

      const {page, itemsPerPage} = this.options;

      const params = {
        offset: page > 1 ? itemsPerPage * (page - 1) : 0,
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      const response = await api.get('/api/offer/joins', {params});
      this.loading = false;

      this.items = response.data.items;
      this.total = response.data.total; // Delay the change a bit to avoid performing another query.
    },
    getStatusText(status) {
      return getStatusText(status);
    },

    update(item) {
      console.log(item);
      api.put('/api/offer/joins/' + item.id, {status: item.status});
    },
  },
  created() {
    this.getList();
  }
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.v-chip {
  white-space: break-spaces !important;
  line-height: 14px;
  width: 100%;
  padding: 9px;
}

.v-chip .v-chip__content {
  max-width: 100%;
  height: auto;
  overflow: auto;
  min-height: 32px;
  white-space: pre-wrap;
}
</style>